import PropTypes from 'prop-types';
import { upgradeDataPropsInterface } from 'ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface';
export const PricingPageRedirectButtonPropsInterface = Object.assign({}, upgradeDataPropsInterface, {
  use: PropTypes.string,
  isSelectableBox: PropTypes.bool,
  onClick: PropTypes.func,
  usageLimitBannerData: PropTypes.object
});